import { name } from '../constants';
var selectHintsState = function (state) { return state[name]; };
export { selectHintsState };
